'use client';

import type { HomeWidgetConverter } from '@/app/_shared/converter/home-widget-converter';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { type FC } from 'react';
import { SubHeader } from '@yanolja-rnd/nol-design-system';
import { clientLogStandardized } from '@weberus/client-tracker';
import { ShowAllButton } from 'app/_components/common/show-all-button';
import { PaneArea } from './pane-area';

type ConvertedCuratedLiveSplitpaneWidgetData = ReturnType<
  typeof HomeWidgetConverter.YDM__NOL_CURATED_LIVE_SPLITPANE__V1
>;

/*
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/CXT/pages/436928525/NOL+YDM__NOL_CURATED_LIVE_SPLITPANE__V1+9.0.0~ API 문서}
 */
export interface CuratedLiveSplitpaneProps {
  data: ConvertedCuratedLiveSplitpaneWidgetData;
  pageNameLog: HomeLogPageNameValue;
}

/**
 *  야놀자 라이브 스플릿패널의 아이템 컴포넌트
 *
 *  @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=434-74460&m=dev}
 */
export const CuratedLiveSplitpane: FC<CuratedLiveSplitpaneProps> = ({ data, pageNameLog }) => {
  const { header, items, logMeta: widgetLogMeta } = data;

  return (
    <div className="my-16 w-full pc:my-40 pc:w-auto pc:max-w-pc-size">
      {!!header?.title && (
        <SubHeader
          className="px-16"
          subTitle={header.subTitle}
          icon={header.icon ? <img src={header.icon} alt="" className="size-20" /> : undefined}
          title={
            <div className="flex items-center">
              <span>{header.title}</span>
            </div>
          }
        />
      )}
      <PaneArea items={items} pageNameLog={pageNameLog} widgetLogMeta={widgetLogMeta} />
      {!!header?.more?.action.web && (
        <ShowAllButton
          boldTitle={header.title}
          title={header.more.title}
          href={header.more.action.web}
          onClick={() => clientLogStandardized('click', pageNameLog, header.more?.logMeta)}
        />
      )}
    </div>
  );
};
